export enum InventoryPageQueryKeys {
  SaveQueryModalOpen = 'saveQuery',
  EditQueryModalOpen = 'editQuery',
  Query = 'query',
  ResourceId = 'resourceId',
  SavedQueryId = 'access_scope_id',
}
